import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Tabs, Tab, Paper } from '@material-ui/core'

import { getShopList } from '../../../actions/shop'

import {
  getACHAccountList,
  createACHAccount,
  updateACHAccount,
  deleteACHAccount,
  getSpenceAccountList,
  setSpenceAccounts,
  updateSpenceAccount,
  createSpenceAccount,
  deleteSpenceAccount,
} from '../../../actions/integration'

import ContainerWithTitleWrapper from '../../HOC/ContainerWithTitle'
import SpenceShopInfo from '../../../components/Spence/SpenceShopInfo'
import { Appcues } from '../../../utils/constants'

const spenceTabs = ['Shop']

class Spence extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeTab: 'Shop',
      editMode: false,
      channelOptions: [],
    }
  }

  componentDidMount() {
    this.props.dispatch(getShopList()).then((res) => {
      this.getSpenceList(res)
    })
  }

  enableEdit = () => {
    this.setState({
      editMode: true,
    })
  }

  disableEdit = () => {
    this.setState({
      editMode: false,
    })
  }

  onChannelCancel = () => {
    const { channelOptions } = this.props.shopReducer
    this.setState({
      channelOptions: channelOptions,
      editMode: false,
    })
  }

  getSpenceList = (shops) => {
    let data = {}
    const { session = {} } = this.props.authReducer
    const { company = {} } = session
    this.props.dispatch(getACHAccountList(company.id)).then((spenceAcounts) => {
      const spenceAcountsValues = (spenceAcounts && spenceAcounts.values) || []
      shops &&
        shops.values &&
        shops.values.length &&
        shops.values.forEach((item) => {
          const spenceAccount =
            spenceAcountsValues.find(
              (acc) => acc.shopId === item.id && acc.paymentOption === 'Spence',
            ) || {}
          data[item.id] = { ...(data[item.id] || {}), ...spenceAccount, shopId: item.id }
        })

      this.props.dispatch(setSpenceAccounts(data))
    })
  }

  spenceTabs = spenceTabs.map((tab) => <Tab label={tab} value={tab} />)

  onShopSave = (data, afterOnSave) => {
    const { shopsList = {} } = this.props.shopReducer
    const { session = {} } = this.props.authReducer
    const { company = {} } = session

    if (company !== null) {
      data = {
        ...data,
        companyId: company.id,
      }
    }

    if (data.id) {
      this.props.dispatch(updateACHAccount(data)).then((response) => {
        Appcues.track('Spence Account Updated')
        this.getSpenceList(shopsList)
        afterOnSave(response)
      })
    } else {
      this.props.dispatch(createACHAccount(data)).then((response) => {
        Appcues.track('Spence Account Created')
        this.getSpenceList(shopsList)
        afterOnSave(response)
      })
    }
  }
  onChannelChange = (index) => (key, value) => {
    const { channelOptions } = this.state

    let updatedChannelOptions = [...channelOptions]

    updatedChannelOptions[index] = { ...updatedChannelOptions[index], [key]: value }

    this.setState({
      channelOptions: updatedChannelOptions,
    })
  }

  renderTab = (activeTab) => {
    const { editMode, channelOptions } = this.state

    const { shopsList = {} } = this.props.shopReducer

    //TODO
    const { spenceList = {} } = this.props.integrationReducer

    const integrationLastModified = this.props.integrationReducer.lastModified

    switch (activeTab) {
      case 'Shop':
        return (
          <SpenceShopInfo
            spenceList={spenceList}
            onSave={this.onShopSave}
            lastModified={integrationLastModified}
            shopsList={shopsList}
            onDelete={this.onShopDelete}
          />
        )
      default:
        return null
    }
  }

  onShopDelete = (accountId) => {
    const { shopsList = {} } = this.props.shopReducer

    this.props.dispatch(deleteACHAccount(accountId)).then((res) => {
      Appcues.track('Spence Account Deleted')
      this.getSpenceList(shopsList)
    })
  }

  handleChange = (event, tab) => {
    this.setState({
      activeTab: tab,
    })
  }

  render() {
    const { activeTab } = this.state

    return (
      <div>
        <Paper>
          <Tabs
            value={activeTab}
            onChange={this.handleChange}
            indicatorColor="primary"
            textColor="primary"
            centered
          >
            {this.spenceTabs}
          </Tabs>
        </Paper>
        {this.renderTab(activeTab)}
        {/* <ModalDialog 
                    title={'Warning'}
                    ref={(c) => this.confirmModal = c}
                    onConfirm={this.createNewWorker}
                    confirmText={'Yes'}
                >
                    <p>This employee doesn't exist, Do you want to create new agent at tookan?</p>
                </ModalDialog> */}
      </div>
    )
  }
}

const SpenceWithTitle = ContainerWithTitleWrapper(Spence, 'Spence Management')
const SpenceConnected = connect(({ shopReducer, integrationReducer, dispatch, authReducer }) => ({
  shopReducer,
  integrationReducer,
  dispatch,
  authReducer,
}))(SpenceWithTitle)

export default SpenceConnected



// WEBPACK FOOTER //
// ./src/containers/Settings/Integration/Spence.js